module.exports = __webpack_public_path__ + "static/media/baseMeme7.7a693a33.jpg";